module.exports = __webpack_public_path__ + "img/success.0bec3ed2.png";